"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportSentryError = void 0;
var sentryClient;
var sentryGlobal = window.Sentry;
if (sentryGlobal && sentryGlobal.BrowserClient) {
    try {
        sentryClient = new sentryGlobal.BrowserClient({
            dsn: 'https://dfc1752d8bd44f2f891ba61ac43e57a9@sentry.wixpress.com/267',
        });
    }
    catch (e) { }
}
function reportSentryError(e) {
    if (sentryClient) {
        try {
            sentryClient.captureException(e);
        }
        catch (e) { }
    }
}
exports.reportSentryError = reportSentryError;
//# sourceMappingURL=SentryReporter.js.map